export class Entitlement {
    constructor(id, productId, isActive, renewState, source, startedTimestamp, renewsCount, grantType, transactions, expirationTimestamp, trialStartTimestamp, firstPurchaseTimestamp, lastPurchaseTimestamp, autoRenewDisableTimestamp, lastActivatedOfferCode) {
        this.id = id;
        this.productId = productId;
        this.isActive = isActive;
        this.renewState = renewState;
        this.source = source;
        this.startedDate = new Date(startedTimestamp);
        this.expirationDate = expirationTimestamp ? new Date(expirationTimestamp) : undefined;
        this.renewsCount = renewsCount;
        this.grantType = grantType;
        this.transactions = transactions;
        this.expirationDate = expirationTimestamp ? new Date(expirationTimestamp) : undefined;
        this.trialStartDate = trialStartTimestamp ? new Date(trialStartTimestamp) : undefined;
        this.firstPurchaseDate = firstPurchaseTimestamp ? new Date(firstPurchaseTimestamp) : undefined;
        this.lastPurchaseDate = lastPurchaseTimestamp ? new Date(lastPurchaseTimestamp) : undefined;
        this.autoRenewDisableDate = autoRenewDisableTimestamp ? new Date(autoRenewDisableTimestamp) : undefined;
        this.lastActivatedOfferCode = lastActivatedOfferCode;
    }
}
//# sourceMappingURL=Entitlement.js.map